import React, { useMemo } from 'react';
import { Section, Text, Column } from '@ydistri/ds';
import { useStableParams } from '../../../routes/useStableParams';
import { useGetAsoScopesQuery } from '../apiAso';
import AsoScope from './AsoScope';
import AsoScopesHeaderAction from './AsoScopesHeaderAction';
import { Empty } from 'antd';
import { AsoValidationIssueMessages } from '../validation/AsoValidationIssueMessages';
import {
  getAsoValidationIssuesForScope,
  getAsoValidationIssuesForScopeList,
} from '../validation/asoValidation';
import { useAsoValidation } from '../validation/useAsoValidation';

const AsoScopes: React.FC = () => {
  const { asoScenarioId } = useStableParams();
  const { issuesByArea } = useAsoValidation();
  const scopeIssues = issuesByArea.scopes;

  const {
    data: scopes,
    isLoading,
    isError,
  } = useGetAsoScopesQuery(asoScenarioId ?? 0, { skip: !asoScenarioId });

  const sortedScopes = useMemo(
    () => [...(scopes ?? [])].sort((a, b) => b.priority - a.priority),
    [scopes],
  );
  const showEmptyState = !isLoading && !isError && sortedScopes.length === 0;
  const showScopes = !isLoading && !isError && Boolean(asoScenarioId) && sortedScopes.length > 0;
  const scopeListIssues = useMemo(
    () => getAsoValidationIssuesForScopeList(scopeIssues),
    [scopeIssues],
  );

  return (
    <Section
      header="ASO scopes"
      headerActions={<AsoScopesHeaderAction asoScenarioId={asoScenarioId} />}
      collapsible
    >
      {isLoading && <Text>Loading ASO scopes…</Text>}
      {isError && <Text $type="danger">Failed to load ASO scopes.</Text>}
      {showEmptyState && (
        <Column $gap="0.5rem">
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No ASO scopes yet" />
          <AsoValidationIssueMessages issues={scopeListIssues} />
        </Column>
      )}
      {showScopes && asoScenarioId && (
        <Column $gap="1rem">
          {sortedScopes.map((scope, i) => (
            <AsoScope
              key={scope.id}
              asoScenarioId={asoScenarioId}
              scope={scope}
              scopeNumber={sortedScopes.length - i}
              validationIssues={getAsoValidationIssuesForScope(scopeIssues, scope.id)}
            />
          ))}
        </Column>
      )}
    </Section>
  );
};

export default AsoScopes;
